import styled from 'styled-components';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
`;

export {
  ButtonContainer,
};
